// 统计首页 API — GET /api/v1/stats
// 返回服务端缓存的统计快照(非实时,后台定期刷新)
import { apiClient } from './client';

export interface RepoSummary {
  full_name: string;
  description: string | null;
  visibility: string;
  created_at: string;
}

export interface UserSummary {
  username: string;
  display_name: string | null;
  created_at: string;
}

export interface StatsSnapshot {
  generated_at: string;
  // 公开指标
  total_users: number;
  total_repos: number;
  public_repos: number;
  private_repos: number;
  total_backups: number;
  last_backup_at: string | null;
  // 需登录的详细列表
  active_users_7d: number;
  total_branches: number;
  recent_repos: RepoSummary[];
  most_active_users: UserSummary[];
}

export const statsApi = {
  /** GET /api/v1/stats */
  async get(): Promise<StatsSnapshot> {
    const { data } = await apiClient.get<StatsSnapshot>('/v1/stats');
    return data;
  },
};
